// src/plugins/sales-forecast/components/PredictControl.tsx
import React from "react";
import { useSystemTheme } from "../hooks/useSystemTheme";
import "../../sales-forecast/styles/theme.css";

interface PredictControlProps {
  onPredict: () => void;
}

export const PredictControl: React.FC<PredictControlProps> = ({ onPredict }) => {
  const theme = useSystemTheme();

  // Pull CSS theme variables
  const css = getComputedStyle(document.documentElement);
  const textColor = css.getPropertyValue("--text-color").trim();
  const accentColor = css.getPropertyValue("--accent-color").trim();
  const inputBg =
    css.getPropertyValue("--input-bg").trim() ||
    css.getPropertyValue("--subcard-bg").trim();
  const borderColor = css.getPropertyValue("--border-color").trim();

  return (
    <button
      onClick={onPredict}
      className={`theme-${theme} transition-all duration-200 rounded-lg font-medium`}
      style={{
        backgroundColor: inputBg, // dark base like input boxes
        color: textColor,
        border: `1px solid ${borderColor}`,
        padding: "0.5rem 1rem",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.15)",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = accentColor;
        e.currentTarget.style.color = "#fff";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = inputBg;
        e.currentTarget.style.color = textColor;
      }}
    >
      Predict Forecast
    </button>
  );
};